module.exports = __webpack_public_path__ + "img/1-prehistoire-light.13f7adfe.svg";